import { Card } from 'react-bootstrap';

export const Indicator = ({ icon, title, value }: { icon: any; title: string; value: any }) => {
  const Icon = icon;
  return (
    <>
      <Card>
        <Card.Body className="d-flex flex-column">
          <div className="mb-2">
            <div className="text-center text-primary mt-3">
              <Icon size="32" />

              <div className="mt-2 pair-value">
                <Card.Text>{value}</Card.Text>
              </div>
            </div>

            <Card.Text className="text-center text-muted">{title}</Card.Text>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default Indicator;
